import { Injectable } from '@angular/core';

@Injectable()
export class DateHelperService {
    constructor() {}

    /**
     *
     * @param date Valid date
     * @param duration In minutes
     */
    addTime(date: Date, duration: number): Date {
        return new Date(date.getTime() + duration * 60000);
    }

    stringToDate(date: string, time: string): Date {
        const arrayTime = time.split(':');
        let hour = arrayTime[0];
        hour = hour.length < 2 ? `0${hour}` : hour;
        const auxTime = `${hour}:${arrayTime[1]}`;
        return new Date(`${date} ${auxTime} UTC`);
    }

    /**
     * Date to string formated like YYYY-MM-DD
     * @param date
     */
    dateToStrFormated(date: Date): string {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    /**
     *
     * @param date string ej. '2020-08-01'
     * @returns Date object with hh:mm:ss to 00:00:00
     */
    getMidnightDateFromString(date: string): Date {
        return new Date(new Date(date + 'UTC').setHours(0, 0, 0));
    }

    /**
     * Convert date to utc date
     * @param date
     */
    convertDateToUTC(date: Date): Date {
        return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    }
}
